import $ from 'jquery';
import {loadFlightSearchCalendars} from '../components/datepicker';
import {loadCustomSelect} from '../components/customselect';

$(() => {
    if($(".weeze__flights-widget").length > 0) {
        loadData();
    }
    $(document).on('click', ".fs__button--flightsearch", (e) => {
        const flightButtonData = $(e.currentTarget).data('ajax');
        loadFlights(flightButtonData, e.currentTarget);
    });
    $(document).on('click', ".fs__button--flightsearch-detail", (e) => {
        let flightDate = $(e.currentTarget).closest('.bt4-row').find('.fs__dateSelect .datepicker_value').html().split(".");
        flightDate = Array.isArray(flightDate) && flightDate.length === 3 ? `${flightDate[2]}-${flightDate[1]}-${flightDate[0]}` : '';
        const flightType = $(e.currentTarget).closest('.bt4-row').find('select.fs__dropdown--flight_type.nrn_custom_select').val();
        const airport = $(e.currentTarget).closest('.bt4-row').find('select.fs__dropdown--airport.nrn_custom_select').val();
        const flightData = {
            search_desc: false,
            search_day: flightDate,
            airport: airport,
            flight_type: flightType,
            url: SiteParameters.ajax_url,
        };
        loadFlights(flightData, e.currentTarget);
    });

    function loadData() {
        jQuery.ajax({
            type: 'GET',
            url: '/api/flights.json',
            success: function (data, textStatus, XMLHttpRequest) {
                $(".weeze__flights-widget .last-date").html(data.return_html_date);
                $(".weeze__flights-widget .last-update").html(data.return_html_update);
                $(".weeze__flights-widget .flight--schedule.fs_arrivals").html(data.return_html_arrivals);
                $(".weeze__flights-widget .flight--schedule.fs_departures").html(data.return_html_departures);
                $(".weeze__flights-widget .flight--schedule.fs_search").html(data.return_html_search);
                loadFlightSearchCalendars();
                loadCustomSelect();
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                //
            }
        });
    }
    function loadFlights(flightButtonData, target) {
        jQuery.ajax({
            type: 'POST',
            url: flightButtonData.url,
            data: {
                action: 'getflights',
                ...flightButtonData,
            },
            success: function (data, textStatus, XMLHttpRequest) {
                const container = $(target).closest('.flight--schedule').find('.fs__flights');
                const container_class = $.trim(container.attr('class')).replace(' ', '. ');
                container.html(data.return_html);
                const buttonGroup = $(target).closest('.fs__footer');
                const buttonLeft = buttonGroup.find('.fs-button-left');
                const buttonRight = buttonGroup.find('.fs-button-right');
                buttonLeft.data('ajax', data.button_left);
                buttonRight.data('ajax', data.button_right);
                data.button_left.last_search ? buttonLeft.removeClass('disabled') : buttonLeft.addClass('disabled');
                data.button_right.last_search ? buttonRight.removeClass('disabled') : buttonRight.addClass('disabled');
                loadFlightSearchCalendars(container_class);
                loadCustomSelect();
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                //
            }
        });
    }
});
